<template>
    <div>
        <v-card
            flat
            class="d-flex justify-end align-center mb-1"
            v-if="settings"
        >
            <slot name="top" />
            <v-btn
                icon
                small
                color="grey lighteen-3"
                class="ml-2 float-right"
                @click="modalColumnDefinition = true"
            >
                <v-icon>mdi-cog</v-icon>
            </v-btn>
        </v-card>
        <v-data-table
            calculate-widths
            :headers="headers"
            :items="items"
            :search="search"
            class="elevation-0"
            hide-default-footer
            :header-props="{ 'sort-icon': 'bi bi-caret-up-fill' }"
        >
            <template v-slot:[`item.delete`]="{ item }">
                <div class="d-flex">
                    <v-btn
                        icon
                        small
                        v-show="icon.show"
                        v-for="(icon, i) in iconButtons"
                        :key="'icon ' + i"
                    >
                        <v-icon
                            size="22"
                            icon
                            @click="ActionButton(icon.ActionLabel, item)"
                            :color="icon.color"
                            >{{ icon.icon }}</v-icon
                        >
                    </v-btn>
                </div>
            </template>

            <template v-slot:[`item.select`]="{ item }">
                <div>
                    {{ item.select }}
                    <v-checkbox
                        :value="item"
                        v-model="model"
                        v-on:change="OnBoxSelected(item)"
                    />
                </div>
            </template>

            <template v-slot:[`header.select`]="{ header }">
                <div>
                    <v-checkbox
                        :value="header"
                        v-on:change="OnBoxSelected('all')"
                    />
                </div>
            </template>

            <template v-slot:[`item.name`]="{ item }">
                <span> {{ item.name.substring(0, 15) }}</span>
            </template>

            <template v-slot:[`item.demandaSemanaAtual`]="{ item }">
                <span v-if="!editing" class="editTxt" @dblclick="editTable()">
                    {{ item.demandaSemanaAtual }}</span
                >
                <div
                    v-if="editing"
                    class=" ml-8 mt-4  d-flex justify-center align-center "
                >
                    <v-text-field
                        outlined
                        class="field  text-center"
                        dense
                        v-model="item.editDemandaSemanaAtual"
                    />
                </div>
            </template>

            <template v-slot:[`item.demandaSemanaUm`]="{ item }">
                <span
                    v-if="!editing1"
                    color="#A5D6A7"
                    label
                    class="editTxt text-center"
                    @dblclick="editing1 = true"
                >
                    {{ item.demandaSemanaUm }}</span
                >
                <div
                    v-if="editing1"
                    class=" ml-8 mt-4  d-flex justify-center align-center "
                >
                    <v-text-field
                        class="field text-center"
                        dense
                        outlined
                        v-model="item.editDemandaSemanaUm"
                    />
                </div>
            </template>

            <template v-slot:[`item.demandaSemanaDois`]="{ item }">
                <span
                    v-if="!editing2"
                    label
                    class="editTxt text-center"
                    @dblclick="editing2 = true"
                >
                    {{ item.demandaSemanaDois }}</span
                >
                <div
                    v-if="editing2"
                    class=" ml-8 mt-4  d-flex justify-center align-center "
                >
                    <v-text-field
                        class="field text-center"
                        dense
                        outlined
                        v-model="item.editDemandaSemanaDois"
                    />
                </div>
            </template>

            <template v-slot:footer v-if="editing || editing1 || editing2">
                <div class="float-right mt-6">
                    <Button
                        v-on:click.native="reset()"
                        label="Cancelar"
                        tipo="secondary"
                        class="mr-3"
                    />
                    <Button
                        label="Salvar"
                        v-on:click.native="
                            ActionButton('edit')
                            reset()
                        "
                    />
                </div>
            </template>
        </v-data-table>
        <div class="text-center pt-2" v-if="pagination">
            <v-pagination
                v-model="currentPage"
                circle
                :length="pageCount"
                :total-visible="totalVisible"
                :items-per-page="itemsPerPage"
            />
        </div>
        <modal-column-definition
            v-if="settings"
            :ActionButton="HandleColumnDefinition"
            :dialog="modalColumnDefinition"
            :columns="settings.availableColumns"
            :parentShowColumns="settings.parentShowColumns"
        />
    </div>
</template>
<script>
import ModalColumnDefinition from '../Modal/Modal-ColumnDefinition.vue'
import Button from '../Button/Button.vue'
export default {
    components: { ModalColumnDefinition },
    name: 'simpletable',
    components: { Button },

    props: {
        items: {
            type: [Array],
            require: true
        },
        headers: {
            type: [Array],
            require: true
        },
        footer: {
            type: Boolean,
            require: false
        },
        search: {
            type: [String, Number],
            require: true
        },
        actionIcon: {
            type: [String, Number, Boolean],
            require: true
        },
        ActionButton: {
            type: Function,
            default(item) {
                return item
            },
            require: false
        },
        iconButtons: {
            type: [Array],
            require: true
        },
        pagination: {
            type: Boolean,
            require: false
        },
        page: {
            type: Number,
            require: false
        },
        itemsPerPage: {
            type: Number,
            require: false
        },
        pageCount: {
            type: Number,
            require: false
        },
        totalVisible: {
            type: Number,
            require: false
        },
        disableCheck: {
            type: Boolean
        },
        settings: Object
    },

    data(i) {
        return {
            editing: false,
            editing1: false,
            editing2: false,
            currentPage: i.page,
            modalColumnDefinition: false,
            showColumns: i.settings ? i.settings.parentShowColumns : null,
            model: [],
            updateModel: {}
        }
    },

    methods: {
        HandleColumnDefinition(value, item) {
            if (value == 'close-definition') {
                this.modalColumnDefinition = false
            } else if (value == 'defined-columns') {
                let headers = []
                Object.keys(this.settings.model.visibleFields).map(c => {
                    if (item[c]) {
                        headers.push({
                            text: this.settings.model.fieldNames[c],
                            value: c == 'color' ? 'color.name' : c,
                            align: 'center'
                        })
                    }
                })
                this.modalColumnDefinition = false
                this.ActionButton('define-columns', headers)
            }
        },

        OnBoxSelected(item) {
            if (item == 'all') {
                if (this.model == this.items) {
                    this.model = []
                    this.$emit('OnBoxSelected', this.model)
                } else {
                    this.model = this.items
                    this.$emit('OnBoxSelected', this.model)
                }
            }
        },

        reset() {
            this.editing = false
            this.editing1 = false
            this.editing2 = false
            this.ActionButton('cancel')
        },

        editTable(v) {
            if (!v) {
                this.reset()
                this.editing = true
            }
            if (v === 1) {
                this.reset()
                this.editing1 = true
            }
            if (v === 2) {
                this.reset()
                this.editing2 = true
            }
        }
    },

    watch: {
        currentPage(newVal) {
            this.ActionButton('page', newVal)
        },
        model(newVal) {
            this.$emit('OnBoxSelected', newVal)
        }
    }
}
</script>
<style scoped src="@/assets/css/simpletable.css"></style>
